// Minimal stroke icons (24x24, currentColor). Returned as SVG markup strings.
const wrap = (inner: string, fill = false) =>
  `<svg viewBox="0 0 24 24" fill="${fill ? "currentColor" : "none"}" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">${inner}</svg>`;

export const Icons: Record<string, string> = {
  cursor: wrap('<path d="M5 3l14 7-6 2-2 6z"/>'),
  crosshair: wrap('<circle cx="12" cy="12" r="2"/><path d="M12 3v5M12 16v5M3 12h5M16 12h5"/>'),
  trendline: wrap('<path d="M4 19L20 5"/><circle cx="4" cy="19" r="1.6"/><circle cx="20" cy="5" r="1.6"/>'),
  hline: wrap('<path d="M3 12h18"/><circle cx="12" cy="12" r="1.6"/>'),
  vline: wrap('<path d="M12 3v18"/><circle cx="12" cy="12" r="1.6"/>'),
  ray: wrap('<path d="M4 19L20 5"/><circle cx="4" cy="19" r="1.6"/>'),
  extended: wrap('<path d="M3 20L21 4"/>'),
  arrow: wrap('<path d="M4 20L20 4"/><path d="M13 4h7v7"/>'),
  rect: wrap('<rect x="4" y="6" width="16" height="12" rx="1"/>'),
  ellipse: wrap('<ellipse cx="12" cy="12" rx="8" ry="6"/>'),
  channel: wrap('<path d="M3 15L15 5M9 19L21 9"/>'),
  fibretr: wrap('<path d="M3 5h18M3 9h18M3 12h18M3 15h18M3 19h18"/>'),
  fibext: wrap('<path d="M3 6h18M3 12h18M3 18h18"/><path d="M6 6l6 6-6 6" stroke-width="1.2"/>'),
  text: wrap('<path d="M5 6h14M12 6v13M9 19h6"/>'),
  pricerange: wrap('<path d="M12 4v16M12 4l-3 3M12 4l3 3M12 20l-3-3M12 20l3-3"/>'),
  daterange: wrap('<path d="M4 12h16M4 12l3-3M4 12l3 3M20 12l-3-3M20 12l-3 3"/>'),
  riskreward: wrap('<rect x="5" y="4" width="14" height="6" rx="1"/><rect x="5" y="14" width="14" height="6" rx="1"/>'),
  long: wrap('<rect x="4" y="4" width="16" height="16" rx="1.5"/><path d="M12 16V8M12 8l-3 3M12 8l3 3"/>'),
  short: wrap('<rect x="4" y="4" width="16" height="16" rx="1.5"/><path d="M12 8v8M12 16l-3-3M12 16l3-3"/>'),
  position: wrap('<rect x="4" y="4" width="16" height="7" rx="1"/><rect x="4" y="13" width="16" height="7" rx="1"/><path d="M8 7.5h8"/>'),
  magnet: wrap('<path d="M6 4v7a6 6 0 0012 0V4M6 4h4v7a2 2 0 004 0V4h4"/>'),
  trash: wrap('<path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13"/>'),
  candles: wrap('<path d="M7 4v4M7 15v5M7 8h0M17 3v6M17 16v5"/><rect x="5" y="8" width="4" height="7" rx="1"/><rect x="15" y="9" width="4" height="7" rx="1"/>'),
  calendar: wrap('<rect x="4" y="5" width="16" height="15" rx="2"/><path d="M4 9h16M8 3v4M16 3v4"/>'),
  fullscreen: wrap('<path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/>'),
  keyboard: wrap('<rect x="3" y="6" width="18" height="12" rx="2"/><path d="M7 10h0M11 10h0M15 10h0M7 14h10"/>'),
  gear: wrap('<circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2"/>'),
  reset: wrap('<path d="M4 12a8 8 0 108-8M4 12V6M4 12h6"/>'),
  fit: wrap('<path d="M4 8V4h4M20 8V4h-4M4 16v4h4M20 16v4h-4"/><path d="M8 14l3-4 2 3 3-5"/>'),
  chevron: wrap('<path d="M6 9l6 6 6-6"/>'),
};
